import type { ICustomUnitNode, ICustomUnitNodeData } from '../interfaces/ICustomUnitNode';

const hasSameRecords = (
  prevRecords: ICustomUnitNodeData['records'],
  nextRecords: ICustomUnitNodeData['records'],
): boolean => {
  const prev = prevRecords ?? [];
  const next = nextRecords ?? [];

  if (prev.length !== next.length) {
    return false;
  }

  return prev.every((prevRecord, index) => {
    const nextRecord = next[index];

    return prevRecord.id === nextRecord.id
      && prevRecord.name === nextRecord.name
      && prevRecord.addressCountry === nextRecord.addressCountry
      && prevRecord.businessUnitType === nextRecord.businessUnitType
      && prevRecord.estimated === nextRecord.estimated;
  });
};

const areCustomUnitNodePropsEqual = (
  prevProps: ICustomUnitNode,
  nextProps: ICustomUnitNode,
): boolean => {
  if (prevProps.id !== nextProps.id || prevProps.parentId !== nextProps.parentId) {
    return false;
  }

  const prevData = prevProps.data;
  const nextData = nextProps.data;

  return prevData.type === nextData.type
    && prevData.draft === nextData.draft
    && prevData.draftServerId === nextData.draftServerId
    && prevData.showDraftDeleteButton === nextData.showDraftDeleteButton
    && prevData.childrenCount === nextData.childrenCount
    && prevData.totalChildrenHeight === nextData.totalChildrenHeight
    && prevData.tempTotalChildrenHeight === nextData.tempTotalChildrenHeight
    && prevData.parentId === nextData.parentId
    && prevData.depth === nextData.depth
    && prevData.isCollapsed === nextData.isCollapsed
    && prevData.isHiddenByParent === nextData.isHiddenByParent
    && prevData.countryGroupId === nextData.countryGroupId
    && prevData.countryGroupSize === nextData.countryGroupSize
    && prevData.isCountryGroupLeader === nextData.isCountryGroupLeader
    && prevData.isCountryGroupCollapsed === nextData.isCountryGroupCollapsed
    && prevData.isHiddenByCountryGroup === nextData.isHiddenByCountryGroup
    && prevData.isAIPanelSelectionEnabled === nextData.isAIPanelSelectionEnabled
    && prevData.isAIPanelSelected === nextData.isAIPanelSelected
    && prevData.isAISessionPreviewSelected === nextData.isAISessionPreviewSelected
    && prevData.isAICardPanelOpen === nextData.isAICardPanelOpen
    && prevData.isDraftReviewMode === nextData.isDraftReviewMode
    && prevData.isScenarioViewMode === nextData.isScenarioViewMode
    && prevData.isScenarioHighlighted === nextData.isScenarioHighlighted
    && prevData.showMonitoringRiskBadge === nextData.showMonitoringRiskBadge
    && prevData.isDragTarget === nextData.isDragTarget
    && prevData.dropZoneType === nextData.dropZoneType
    && prevData.draggingNodeType === nextData.draggingNodeType
    && prevData.tempHeight === nextData.tempHeight
    && prevData.tempYOffset === nextData.tempYOffset
    && prevData.name === nextData.name
    && prevData.businessUnitType === nextData.businessUnitType
    && prevData.estimated === nextData.estimated
    && prevData.aiMetadata === nextData.aiMetadata
    && prevData.onExpandCountryGroupStack === nextData.onExpandCountryGroupStack
    && prevData.onToggleAIPanelCardSelection === nextData.onToggleAIPanelCardSelection
    && prevData.onToggleUnitCollapse === nextData.onToggleUnitCollapse
    && prevData.onDeleteDraftUnit === nextData.onDeleteDraftUnit
    && hasSameRecords(prevData.records, nextData.records);
};

export default areCustomUnitNodePropsEqual;
